import { LegacyHttpProvider, legacyGetAccounts, signLegacyMessage } from "./web3Compat";
import {
    REACT_APP_CHAIN_ID,
    REACT_APP_RPC_TARGET,
    REACT_APP_WALLET_CLIENT_ID,
    REACT_APP_WEB3AUTH_VERIFIER_NAME,
    REACT_APP_WEB3AUTH_NETWORK
} from "../../config";
import { CHAIN_NAMESPACES } from "@web3auth/base";
import { Web3AuthNoModal } from "@web3auth/no-modal"
import { AuthAdapter } from "@web3auth/auth-adapter";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import { currentWeb3authRedirectUrl } from "../../utils/web3authRedirectUrl";

export default class EthereumRpc {
    provider;

    constructor(provider) {
        if (!provider) {
            provider = new LegacyHttpProvider(
                REACT_APP_RPC_TARGET
            )
        }
        this.provider = provider;
    }

    async getAccounts() {
        try {
            // Get user's Ethereum public address
            const address = (await legacyGetAccounts(this.provider))[0];

            return address;
        } catch (error) {
            return error;
        }
    }

    async signMessage(message = "YOUR_MESSAGE") {
        try {
            // Get user's Ethereum public address
            // (unused, but keep it: this request and its failure are part of what signMessage returns)
            const fromAddress = (await legacyGetAccounts(this.provider))[0];

            const originalMessage = message;

            // Sign the message
            const pkey = await this.getPrivateKey()
            const signedMessage = await signLegacyMessage(
                originalMessage,
                pkey
            );

            const testtext = 'T96DTISe2UtmisYJqi4I'
            const signedMessage2 = await signLegacyMessage(
                testtext,
                pkey
            );
            console.log("TEST SIGN2", signedMessage2)

            return signedMessage;
        } catch (error) {
            return error;
        }
    }

    async getPrivateKey() {
        try {
            const privateKey = await this.provider.request({
                method: "eth_private_key",
            });

            return privateKey;
        } catch (error) {
            return error;
        }
    }
}

const chainConfig = {
    chainNamespace: CHAIN_NAMESPACES.EIP155,
    chainId: REACT_APP_CHAIN_ID,
    rpcTarget: REACT_APP_RPC_TARGET,
};

const privateKeyProvider = new EthereumPrivateKeyProvider({
    config: { chainConfig },
});

export const initWeb3 = () => {
    return new Web3AuthNoModal({
        clientId: REACT_APP_WALLET_CLIENT_ID,
        chainConfig: { // this is ethereum chain config, change if other chain(Solana, Polygon)
            chainNamespace: CHAIN_NAMESPACES.EIP155,
            chainId: REACT_APP_CHAIN_ID,
            rpcTarget: REACT_APP_RPC_TARGET
        },
        uiConfig: {
            appName: " ",
            logoLight: "https://anicana.org/levica.svg",
            logoDark: "https://anicana.org/levica.svg",
            defaultLanguage: "en",
            mode: 'dark', // whether to enable dark mode. defaultValue: light
            useLogoLoader: true,
        },
        privateKeyProvider,
    });
}

export const authAdapter = () => {
    console.log("VERIFIER:" + REACT_APP_WEB3AUTH_VERIFIER_NAME)
    return new AuthAdapter({
        privateKeyProvider,
        adapterSettings: {
            clientId: REACT_APP_WALLET_CLIENT_ID,
            network: REACT_APP_WEB3AUTH_NETWORK,
            uxMode: "redirect",
            // Keep the query string (r / response_type) on the way back from Web3Auth.
            // Without this the library returns to pathname only and the callback is lost.
            redirectUrl: currentWeb3authRedirectUrl(),
            loginConfig: {
                jwt: {
                    name: "ANICANA　θυρα",
                    verifier: REACT_APP_WEB3AUTH_VERIFIER_NAME,
                    typeOfLogin: "jwt",
                    clientId: "1",
                },
            },
        }
    });
}
